import classnames from "classnames";
import React, { ComponentType, FC, ReactHTML } from "react";

import style from "./LoadingSpinner.module.scss";

export interface LoadingSpinnerProps {
  component?: keyof ReactHTML | ComponentType<{ className?: string }>;
  small?: boolean;
  className?: string;
}

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ component: Component = "span", className, small }) => (
  <Component className={classnames(className, style.spinner, { [style.small]: small })} />
);
